<app-elevation-section [title]="languageService.LNG('Label.Times')">
  <div class="grid-totals-wrapper">
    <dx-select-box
      [dataSource]="timeTypeDataSource"
      displayExpr="Code"
      searchExpr="Code"
      valueExpr="TimeTypeId"
      [searchEnabled]="true"
      [showClearButton]="true"
      [(value)]="newTime.TimeTypeId"
      [readOnly]="isEditingDisabled"
      placeholder="{{languageService.LNG('Label.TimeType')}}">
    </dx-select-box>
    <dx-text-box placeholder="{{languageService.LNG('Label.Hours')}}" 
      [(value)]="newTime.Hours" 
      [readOnly]="isEditingDisabled"
      (onEnterKey)="createNewTime()"></dx-text-box>
    <dx-text-box placeholder="{{languageService.LNG('Label.Minutes')}}" 
      [(value)]="newTime.Minutes" 
      [readOnly]="isEditingDisabled"
      (onEnterKey)="createNewTime()"></dx-text-box>
  </div>
  <dx-data-grid #datagriddx
              [dataSource]="gridDataSource"
              [rowAlternationEnabled]="true"
              [columnAutoWidth]="true"
              [height]="192"
              width="100%"
              style="padding-bottom: 10px;"
              (onRowUpdating)="onRowUpdating($event)"
              (onEditorPreparing)="onEditorPreparing($event)"
              (onRowRemoving)="onRowRemoving($event)">
      <dxo-paging [pageSize]="15"></dxo-paging>
      <dxo-editing mode="cell"
                  [allowUpdating]="!isEditingDisabled"
                  [allowAdding]="false"
                  [allowDeleting]="!isEditingDisabled"
                  [useIcons]="true">
      </dxo-editing>
      <dxo-load-panel [enabled]="true"></dxo-load-panel>
      <dxo-scrolling mode="virtual"></dxo-scrolling>

      <dxi-column dataField="TimeTypeId" caption="{{languageService.LNG('Label.TimeType')}}" [width]="100"  >
          <dxo-lookup [dataSource]="timeTypeDataSource"
            displayExpr="Code"
            valueExpr="TimeTypeId">
          </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="TotSecondsToHH" caption="{{languageService.LNG('Label.Hours')}}" [width]="65" alignment="right">
        <dxi-validation-rule type="range" min="0" [message]="validateHoursMessage"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="TotSecondsTomm" caption="{{languageService.LNG('Label.Minutes')}}" [width]="80" alignment="left">
        <dxi-validation-rule type="range" min="0" max="59" [message]="validateMinutesMessage"></dxi-validation-rule>
      </dxi-column>
      <div *dxTemplate="let data of 'headerTitle'">
        <span style="font-size: 20px;" >{{this.languageService.LNG("Label.Times")}}</span>
      </div>
  </dx-data-grid>
</app-elevation-section>
